const aHrefRegex = new RegExp(/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/, 'g')

export const transformAHrefUrlsInHtml = (
  html: string,
  transformFn: (originalUrl: string) => string
) => {
  return html.replace(aHrefRegex, (match, prefix, url, postfix) => {
    return `<a href="${transformFn(url)}"`
  })
}
